import SpriteSymbol from "../../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/_svg-sprite-loader@6.0.9@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "watch",
  "use": "watch-usage",
  "viewBox": "0 0 14 10",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 10\" id=\"watch\"><g fill-rule=\"evenodd\"><path d=\"M7 8.5C4.598 8.5 2.505 7.111 1.652 5 2.505 2.889 4.598 1.5 7 1.5c2.401 0 4.495 1.389 5.348 3.5C11.495 7.111 9.401 8.5 7 8.5M7 0C3.683 0 .897 2.11 0 5c.897 2.89 3.683 5 7 5s6.103-2.11 7-5c-.897-2.89-3.683-5-7-5\" /><path d=\"M7.043 2.585a2.332 2.332 0 100 4.664 2.332 2.332 0 000-4.664\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id